module.exports = __webpack_public_path__ + "static/profile-logo-686534a3a2699d262738a59640d9007d.jpg";